import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';

import { logError } from 'utils/errorHandling';
import { ReduxState } from 'redux/root-reducer';
import { LS_STATE_KEY } from 'utils/localStorage';

let prevState: ReduxState | undefined;

export const getLocalStorageReduxState = (() => {
    const localStorageState = localStorage[LS_STATE_KEY];

    if (localStorageState === undefined) {
        return {} as ReduxState;
    }

    try {
        const state = JSON.parse(localStorageState);
        prevState = state;

        return state as ReduxState;
    } catch (e) {
        logError(`Error fetching ${LS_STATE_KEY} from localStorage`, e);

        return {} as ReduxState;
    }
})();

export const persistToLocalStorage: Middleware<Dispatch> = (store: MiddlewareAPI) => (next) => (action: AnyAction) => {
    next(action);

    // For now persist only auth and account data
    const { auth, account } = store.getState();

    if (prevState?.auth !== auth || prevState?.account !== account) {
        localStorage[LS_STATE_KEY] = JSON.stringify({ auth, account });
        prevState = { auth, account } as ReduxState;
    }
};
